export const EXCMDEVICEBRAND_DELETE_RESET = 'EXCMDEVICEBRAND_DELETE_RESET'
export const EXCMDEVICEBRAND_DELETE_SET_ERROR = 'EXCMDEVICEBRAND_DELETE_SET_ERROR'
export const EXCMDEVICEBRAND_DELETE_SET_DELETED = 'EXCMDEVICEBRAND_DELETE_SET_DELETED'
export const EXCMDEVICEBRAND_DELETE_TOGGLE_LOADING = 'EXCMDEVICEBRAND_DELETE_TOGGLE_LOADING'
